(function ($) {
  "use strict";
  $(function () {

    objectFitImages();

    // Search

    $('.js-show-service-info').on('click', function (e) {
      e.preventDefault();
      $(this).parent().next('.info__text').slideToggle();
    })

    $('.js-show-service-details').on('click', function (e) {
      e.preventDefault();
      var tab = $(this).data('tabid')
      $('.js-section-services.active').removeClass('active');
      $(`#${tab}`).addClass('active');
      var offset = $('header').height() + 50;

      $('html,body').animate({ scrollTop: $(`#${tab}`).offset().top - offset }, 100);
    })


    $('.js-show-services').on('click', function (e) {
      e.preventDefault();
      var tab = 'tab_main';
      $('.js-section-services.active').removeClass('active');
      $(`#${tab}`).addClass('active');
      var offset = $('header').height() + 50;

      $('html,body').animate({ scrollTop: $(`#${tab}`).offset().top - offset }, 100);
    })


    if ($('.iframe-modal').length) {
      $(".iframe-modal").iziModal({
        history: false,
        iframe: true,
        fullscreen: true,
        headerColor: '#5c18b9 ',
        openFullscreen: false,
        focusInput: false,
        bodyOverflow: true,
        zindex: 9999,
        iframeHeight: 600,
        radius: 0,
        borderBottom: false,
        width: $('.container').width(),

        onOpening: function () {
          $('.iframe-modal').find('iframe').attr('allowfullscreen', 'allowfullscreen');
        }
      });

    }




    $(window).on('scroll', function () {
      var threshold = 200;
      var op = (($(document).height() - $(window).height() - 100) - $(window).scrollTop()) / threshold;

      if (op <= 0.2 && window.innerWidth <= 767) {
        $(".js-szechenyi").removeClass('active');
      } else {
        $(".js-szechenyi").addClass('active');
      }
    });

    $('a[href="#search"]').on("click", function (event) {
      event.preventDefault();
      $("#search-layer").addClass("open");
      $('#search-layer > form > input[name="s"]').focus();
    });

    $("#search-layer, #search-layer button.close").on("click keyup", function (event) {
      if (
        event.target == this ||
        event.target.className == "close" ||
        event.keyCode == 27
      ) {
        $(this).removeClass("open");
      }
    });

    // Header class

    $(window).scroll(function () {
      if ($(this).scrollTop() > 0) {
        $('.main-header').addClass('scrolled');
      } else {
        $('.main-header').removeClass('scrolled');
      }
    });


    // MenuBtn
    var button = document.querySelector('.bt-menu-trigger');
    button.addEventListener('click', function () {
      button.classList.toggle('bt-menu-open');
    });

    $('.navbar-toggler').on('click', function () {
      $('body').toggleClass('js-mobile-menu-open');
    });


    // Sliders
    $('.js-video-slider').on('init', function (event, slick) {
    }).on('afterChange', function (e, o) {
      $('.video-section iframe').each(function () {
        $(this)[0].contentWindow.postMessage('{"event":"command","func":"' + 'stopVideo' + '","args":""}', '*');
      });
    }).slick({
      dots: true,
      arrows: false,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            arrows: false,
            dots: true
          }
        },
      ]
    });

    if ($('.slider.mainslider').length) {
      $('.slider.mainslider').each(function (index, el) {
        var $that = $(this).parent();

        $(this).on('init reInit', function (event, slick) {
          var current = slick.slideCount / parseFloat(slick.options.slidesToShow);
          if (current > 1) {
            var currentrounded = Math.ceil(current.toFixed(2));
            $that.find('.slider-counter').append('<span class="first-number">1</span><span class="temp">/</span><span class="second-number">' + currentrounded + '</span>');
          }
        });

        $(this).slick({
          infinite: true,
          slidesToShow: 3,
          slidesToScroll: 3,
          responsive: [
            {
              breakpoint: 992,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true
              }
            }
          ]
        });

        $(this).on('afterChange', function (event, slick, currentSlide, nextSlide) {
          var i = (currentSlide ? currentSlide : 0) + slick.options.slidesToShow;
          var current = slick.slideCount / parseFloat(slick.options.slidesToShow);
          if (current > 1) {
            var currentrounded = Math.ceil(current.toFixed(2));
            $that.find('.first-number').text(i / parseFloat(slick.options.slidesToShow));
            $that.find('.second-number').text(currentrounded);
          }
        });
      });
    }


    /* OLD SLIDER */

    if ($('.slider.blogslider').length) {
      $('.slider.blogslider').each(function (index, el) {
        var $that = $(this).parent();

        $(this).on('init reInit', function (event, slick) {
          var current = slick.slideCount / parseFloat(slick.options.slidesToShow);
          if (current > 1) {
            var currentrounded = Math.ceil(current.toFixed(2));
            $that.find('.slider-counter').append('<span class="first-number">1</span><span class="temp">/</span><span class="second-number">' + currentrounded + '</span>');
          }
        });

        $(this).slick({
          infinite: true,
          slidesToShow: 2,
          slidesToScroll: 2,
          responsive: [
            {
              breakpoint: 992,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true
              }
            }
          ]
        });

        $(this).on('afterChange', function (event, slick, currentSlide, nextSlide) {
          var i = (currentSlide ? currentSlide : 0) + slick.options.slidesToShow;
          var current = slick.slideCount / parseFloat(slick.options.slidesToShow);
          if (current > 1) {
            var currentrounded = Math.ceil(current.toFixed(2));
            $that.find('.first-number').text(i / parseFloat(slick.options.slidesToShow));
            $that.find('.second-number').text(currentrounded);
          }
        });
      });
    }


    // App functions
    $('.functions .btn--whitening').on('click', function () {
      var currentText = $(this).text();

      $(this).text(currentText.trim() == localize.translations.show_all ? localize.translations.show_less : localize.translations.show_all);
      $('.more').slideToggle();
    });


    /* Validate phone */

    var hasLetterRegex = /[a-zA-Z]/;
    function removeLetters(string) {
      var r = new RegExp(hasLetterRegex, 'g');
      return string.replace(r, '');
    }
    function formatPhoneNumber(string) {
      return '+' + removeLetters(string).replace('+', '').replace(' ', '');
    }

    $('.js-validate-phone').on("keypress keyup blur", function () {
      this.value = formatPhoneNumber(this.value);
    });


    // Post type scroll
    $(".selector a").on("click", function (e) {
      e.preventDefault();

      var offset = $('header').height() + 50;

      $('html,body').animate({ scrollTop: $($(this).attr("href")).offset().top - offset }, 500);
    });

    // Percentage

    $("#t1q5").click(function () {
      $(this).val('');
    });

    $("#t1q5").keyup(function () {
      $('.percentage--panel').html($('#t1q5').val() + "%");
    });

    // Offer table

    $('.open-packages.open-desktop a').on('click', function () {
      $('.open-packages .arrow').toggleClass('opened');
      $('.package-table.desktop-table').slideToggle();
    });

    $('.open-mobile .open-packages .btn--whitening').on('click', function () {
      $('.open-packages .arrow').toggleClass('opened');
      $('.package-table.mobile-table').slideToggle();
    });

    if ($("#hero__video").length) {
      $("#hero__video").iziModal({
        history: false,
        iframe: false,
        fullscreen: true,
        headerColor: '#5c18b9',
        openFullscreen: false,
        focusInput: false,
        radius: 0,
        onOpened: function () {
          //
        },
        onClosed: function () {
          //$('#hero__video').find('iframe').attr('src','');
          $('#hero__video').find('iframe')[0].contentWindow.postMessage('{"event":"command","func":"' + 'stopVideo' + '","args":""}', '*');
        },
      });
    }

    $('.lang ul li').on('click', function () {
      var label = $(this).parent().parent().children('label');
      label.attr('data-value', $(this).attr('data-value'));
      label.html($(this).html());

      $(this).parent().children('.selected').removeClass('selected');
      $(this).addClass('selected');
    });

  });
})(jQuery);
